import { PRODUCT_LIST } from "../constants";

// Action creator to initiate fetching the product list
export const productList = () => {
  return {
    type: PRODUCT_LIST,
  };
};
